export default [
  {
    name: 'Bet > Settle Win',
    functionName: 'bet_settleWin',
  },
  {
    name: 'Bet > Settle Lose',
    functionName: 'bet_settleLose',
  },
  {
    name: 'Bet > Settle Win 5 times',
    functionName: 'bet_settleWin5Times',
  },
  {
    name: 'Bet > (Network) Settle Win 5 times',
    functionName: 'bet_asyncSettleWin5Times',
  },
  {
    name: 'Multi Bets - Place 2 bets > Settle Win',
    functionName: 'multiBets_bet1_bet2_settleWin',
  },
  {
    name: 'Bet > CancelBet',
    functionName: 'bet_cancelBet',
  },
  {
    name: 'Bet > CancelBet 5 times',
    functionName: 'bet_cancelBet5Times',
  },
  {
    name: 'CancelBet only',
    functionName: 'cancelBetOnly',
  },
  {
    name: 'CancelBet > Bet',
    functionName: 'cancelBet_bet',
  },
  {
    name: 'Place 3 bets in 3 rounds > CancelBet',
    functionName: 'bet1_bet2_bet3_cancelBet123',
  },

  {
    name: 'Bet > Settle Win > Resettle Lose > Resettle Win',
    functionName: 'bet_settleWin_resettleLose_resettleWin',
  },
  {
    name: 'Bet > Settle Lose > Resettle 5 times',
    functionName: 'bet_settleLose_resettleWin5Times',
  },
  // {
  //   name: 'Negative Balance - Settle Win > Resettle Lose',
  //   functionName: 'negativeBalance_bet1_settleWin1_bet2_resettleLose1_settleTie2',
  // },
  {
    name: 'Positive Balance - Bet',
    functionName: 'positiveBalance_bet',
  },
  {
    name: 'Zero Balance - Bet',
    functionName: 'zeroBalance_bet',
  },
  {
    name: 'Negative Balance - Bet',
    functionName: 'negativeBalance_bet',
  },
]
